/* OViT Home — behaviours for the ovit-* sections. No dependencies. */
/* Linked from every ovit-* section, so a page can carry this tag several times and the browser runs each
   copy. Everything below runs once. */
if (!window.__ovitHome) { window.__ovitHome = true;

(function () {
  'use strict';

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ------------------------------------------------------------------ */
  /* Review wall: Read more                                              */
  /* ------------------------------------------------------------------ */
  function bindReviewToggles(root) {
    (root || document).querySelectorAll('.ovit-review__toggle').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        var card = btn.closest('.ovit-review, .ovit-page');
        if (!card) return;
        var open = card.classList.toggle('is-open');
        btn.textContent = open ? (btn.dataset.less || 'Less') : (btn.dataset.more || 'Read more');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* Strip: once the visitor has scrolled the row, the rules can stop shimmering */
  function bindStrips(root) {
    (root || document).querySelectorAll('.ovit-strip').forEach(function (strip) {
      if (strip.dataset.bound) return;
      strip.dataset.bound = '1';
      strip.addEventListener('scroll', function () {
        if (strip.scrollLeft > 8) strip.classList.add('is-scrolled');
      }, { passive: true });
    });
  }

  /* Strip "slices" (phone): tap a folded type to unfold it into its bags; tap the open
     type's label to fold it back; bags inside the open type are ordinary links. */
  function bindSlices(root) {
    (root || document).querySelectorAll('.ovit-strip--slices').forEach(function (strip) {
      if (strip.dataset.sliceBound) return;
      strip.dataset.sliceBound = '1';
      strip.addEventListener('click', function (e) {
        if (!window.matchMedia('(max-width: 699px)').matches) return;
        var group = e.target.closest('.ovit-strip__group');
        if (!group || !strip.contains(group)) return;
        if (group.classList.contains('is-expanded')) {
          if (e.target.closest('.ovit-strip__head')) {
            e.preventDefault();
            group.classList.remove('is-expanded');
            strip.classList.remove('has-expanded');
          }
          return;
        }
        e.preventDefault();
        strip.querySelectorAll('.ovit-strip__group.is-expanded').forEach(function (g) { g.classList.remove('is-expanded'); });
        group.classList.add('is-expanded');
        strip.classList.add('has-expanded');
      });
    });
  }

  /* Welcome offer: instant; any answer sets a cookie for N days */
  function bindOffer(root) {
    (root || document).querySelectorAll('.ovit-offer').forEach(function (offer) {
      if (offer.dataset.bound) return;
      offer.dataset.bound = '1';
      var days = parseInt(offer.dataset.days, 10) || 30;
      var editor = offer.classList.contains('ovit-offer--editor');
      function remember() {
        if (editor) return;
        try { document.cookie = 'ovit_offer=1; max-age=' + (days * 86400) + '; path=/; SameSite=Lax'; } catch (e) {}
      }
      function close() { remember(); offer.classList.add('is-hidden'); document.documentElement.classList.remove('ovit-offer-open'); }
      function show(state) {
        offer.querySelectorAll('[data-state]').forEach(function (el) { el.hidden = el.dataset.state !== state; });
        var focus = offer.querySelector('[data-state="' + state + '"] input, [data-state="' + state + '"] .ovit-btn');
        if (focus) focus.focus();
      }
      offer.querySelectorAll('[data-offer-close]').forEach(function (el) {
        el.addEventListener('click', function (e) { if (el.tagName !== 'A') e.preventDefault(); close(); });
      });
      var yes = offer.querySelector('[data-offer-yes]');
      if (yes) yes.addEventListener('click', function () {
        if (offer.dataset.mode === 'code') { remember(); show('code'); } else { show('email'); }
      });
      var back = offer.querySelector('[data-offer-back]');
      if (back) back.addEventListener('click', function () { show('offer'); });
      var copy = offer.querySelector('[data-offer-copy]');
      if (copy) copy.addEventListener('click', function () {
        var code = offer.querySelector('[data-offer-code]').dataset.offerCode;
        if (navigator.clipboard) navigator.clipboard.writeText(code).then(function () { copy.textContent = 'Copied'; });
      });
      var form = offer.querySelector('form');
      if (form) form.addEventListener('submit', function () { remember(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !offer.classList.contains('is-hidden')) close(); });
      if (!offer.classList.contains('is-hidden') && !document.documentElement.classList.contains('ovit-offer-seen')) {
        document.documentElement.classList.add('ovit-offer-open');
        var first = offer.querySelector('.ovit-offer__yes');
        if (first && !editor) first.focus({ preventScroll: true });
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /* Choose your Max — the add-to-cart engine (9.9.26)                   */
  /* Every .ovit-bag[data-key] shares one chosen colorway per bag across */
  /* the cards, the compact rows and the compare table.                  */
  /* ------------------------------------------------------------------ */
  var CHOICE_KEY = 'ovit-choice';
  var choice = {};
  try { choice = JSON.parse(sessionStorage.getItem(CHOICE_KEY) || '{}') || {}; } catch (e) { choice = {}; }
  function saveChoice() { try { sessionStorage.setItem(CHOICE_KEY, JSON.stringify(choice)); } catch (e) {} }

  function bagOptions(bag) {
    if (!bag._opts) {
      try { bag._opts = JSON.parse(bag.getAttribute('data-options') || '[]') || []; } catch (e) { bag._opts = []; }
    }
    return bag._opts;
  }

  function applyBag(bag, i) {
    var opts = bagOptions(bag);
    if (!opts.length) return;
    i = Math.max(0, Math.min(parseInt(i, 10) || 0, opts.length - 1));
    var o = opts[i];
    bag.dataset.index = i;
    bag.querySelectorAll('[data-bag-img]').forEach(function (img) {
      if (!o.img) return;
      if (img.getAttribute('src') !== o.img) {
        img.src = o.img;
        if (o.srcset) img.srcset = o.srcset; else img.removeAttribute('srcset');
      }
      img.alt = o.alt || '';
    });
    bag.querySelectorAll('[data-bag-color]').forEach(function (el) { el.textContent = o.color || ''; });
    bag.querySelectorAll('[data-bag-price]').forEach(function (el) { el.innerHTML = o.price || ''; });
    bag.querySelectorAll('[data-bag-link]').forEach(function (a) { if (o.url) a.href = o.url; });
    /* a new colorway restarts the reel on that colorway's own photo */
    bag.querySelectorAll('.ovit-choose__media--slides').forEach(function (m) { if (m._slidesReset) m._slidesReset(); });
    bag.querySelectorAll('.ovit-swatch').forEach(function (sw) {
      var on = parseInt(sw.dataset.i, 10) === i;
      sw.classList.toggle('is-selected', on);
      sw.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    bag.querySelectorAll('[data-bag-add]').forEach(function (btn) {
      btn.dataset.variant = o.variant || '';
      if (btn.classList.contains('is-busy') || btn.classList.contains('is-added')) return;
      if (!o.available || !o.variant) {
        btn.disabled = true;
        btn.textContent = btn.dataset.soldout || 'Sold out';
      } else {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Add to cart';
      }
    });
  }

  function chooseKey(key, i, from) {
    if (!key) return;
    choice[key] = i;
    saveChoice();
    document.querySelectorAll('.ovit-bag[data-key="' + key + '"]').forEach(function (b) { if (b !== from) applyBag(b, i); });
  }

  function bindBags(root) {
    (root || document).querySelectorAll('.ovit-bag').forEach(function (bag) {
      if (bag.dataset.bound) return;
      bag.dataset.bound = '1';
      var key = bag.dataset.key;
      var i = (key && choice[key] != null) ? choice[key] : bag.dataset.index;
      applyBag(bag, i);
      bag.addEventListener('click', function (e) {
        var sw = e.target.closest('.ovit-swatch');
        if (sw && bag.contains(sw)) {
          e.preventDefault();
          var n = parseInt(sw.dataset.i, 10) || 0;
          applyBag(bag, n);
          chooseKey(key, n, bag);
          return;
        }
        var add = e.target.closest('[data-bag-add]');
        if (add && bag.contains(add)) {
          e.preventDefault();
          addToCart(add, bag);
        }
      });
    });
  }

  /* After an add: ask Venue's cart store to refresh (its <cart-link> updates the count),
     else read /cart.js and write the count ourselves. Never opens the drawer. */
  function refreshCart() {
    var p;
    try { p = (new Function('return import("cart-store")'))(); } catch (e) { p = Promise.reject(e); }
    return p.then(function (m) {
      var Cart = m && m.default;
      if (Cart && typeof Cart.refresh === 'function') return Cart.refresh();
      throw new Error('no cart store');
    }).catch(function () {
      return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('items-count').forEach(function (el) { el.textContent = cart.item_count; });
          document.querySelectorAll('.js-cart-icon').forEach(function (el) { el.classList.toggle('js-cart-full', cart.item_count > 0); });
          return cart;
        });
    });
  }

  function addToCart(btn, bag) {
    if (btn.disabled || btn.classList.contains('is-busy')) return;
    var id = parseInt(btn.dataset.variant, 10);
    if (!id) return;
    var label = btn.dataset.label || btn.textContent;
    var err = bag ? bag.querySelector('.ovit-bag__error') : null;
    if (err) err.textContent = '';
    btn.classList.add('is-busy');
    btn.textContent = btn.dataset.adding || 'Adding…';
    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart');
          return j;
        });
      })
      .then(function () { return refreshCart().catch(function () { return null; }); })
      .then(function (cart) {
        btn.classList.remove('is-busy');
        btn.classList.add('is-added');
        btn.textContent = btn.dataset.added || 'Added';
        setTimeout(function () { btn.classList.remove('is-added'); btn.textContent = label; }, 2000);
        if (btn.hasAttribute('data-drawer')) openDrawer(cart && cart.item_count);
      })
      .catch(function (e) {
        btn.classList.remove('is-busy');
        btn.textContent = label;
        if (err) err.textContent = (e && e.message) || 'Could not add to cart';
      });
  }

  /* Phone: the cards become one card with a tab row (variant B) */
  function bindChooseTabs(root) {
    (root || document).querySelectorAll('.ovit-choose--cards').forEach(function (sec) {
      if (sec.dataset.tabsBound) return;
      sec.dataset.tabsBound = '1';
      var tabs = sec.querySelectorAll('.ovit-choose__tab');
      var cards = sec.querySelectorAll('.ovit-choose__card');
      if (!tabs.length) return;
      function show(key) {
        tabs.forEach(function (t) { var on = t.dataset.key === key; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on ? 'true' : 'false'); });
        cards.forEach(function (c) { c.classList.toggle('is-active', c.dataset.key === key); });
      }
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.key); }); });
      sec._showTab = show;
      show(tabs[0].dataset.key);
    });
  }

  /* Phone: the sticky bar appears once the cards have scrolled away, hides over the compact chooser and the footer */
  function bindSticky(root) {
    (root || document).querySelectorAll('.ovit-sticky').forEach(function (bar) {
      if (bar.classList.contains('ovit-sticky--pdp')) return;
      /* its own flag: the bar is also an .ovit-bag (the colorway sync), and bindBags marks that "bound" first */
      if (bar.dataset.stickyBound || !('IntersectionObserver' in window)) return;
      bar.dataset.stickyBound = '1';
      var sec = bar.closest('.ovit-choose');
      if (!sec) return;
      var past = false, compactOn = false, footOn = false;
      function update() {
        var on = past && !compactOn && !footOn;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      new IntersectionObserver(function (en) {
        var e = en[0];
        past = !e.isIntersecting && e.boundingClientRect.bottom < 0;
        update();
      }, { threshold: 0 }).observe(sec);
      var compact = document.querySelector('.ovit-choose--compact');
      if (compact) new IntersectionObserver(function (en) { compactOn = en[0].isIntersecting; update(); }, { threshold: 0 }).observe(compact);
      var footer = document.querySelector('.footer') || document.querySelector('footer');
      if (footer) new IntersectionObserver(function (en) { footOn = en[0].isIntersecting; update(); }, { threshold: 0 }).observe(footer);
    });
  }

  /* Product page: the "Added" drawer — what went in, Checkout, complete the set */
  function openDrawer(count) {
    var d = document.querySelector('.ovit-drawer');
    if (!d) return;
    if (count != null) d.querySelectorAll('[data-drawer-count]').forEach(function (el) { el.textContent = count; });
    d.hidden = false;
    document.documentElement.classList.add('ovit-drawer-open');
    var sheet = d.querySelector('.ovit-drawer__sheet');
    if (sheet) sheet.focus({ preventScroll: true });
  }
  function closeDrawer() {
    var d = document.querySelector('.ovit-drawer');
    if (!d || d.hidden) return;
    d.hidden = true;
    document.documentElement.classList.remove('ovit-drawer-open');
  }
  function bindDrawer(root) {
    (root || document).querySelectorAll('.ovit-drawer').forEach(function (d) {
      if (d.dataset.bound) return;
      d.dataset.bound = '1';
      d.querySelectorAll('[data-drawer-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
    });
    if (!document.documentElement.dataset.ovitDrawerKeys) {
      document.documentElement.dataset.ovitDrawerKeys = '1';
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
    }
  }

  /* Product page: the phone sticky bar appears once the buy block has scrolled away, hides over the closing band */
  function bindPdpSticky(root) {
    (root || document).querySelectorAll('.ovit-sticky--pdp').forEach(function (bar) {
      /* its own flag (Sep 10 fix): the bar is also an .ovit-bag, and bindBags had already marked it "bound",
         so the observers below were never attached and the phone bar never appeared on the live site */
      if (bar.dataset.stickyBound || !('IntersectionObserver' in window)) return;
      bar.dataset.stickyBound = '1';
      /* the bar exists to keep Add to cart in reach: it appears once the button has scrolled away, not after the
         whole buy column (spec list, Designer's Notes) has passed */
      var buy = document.querySelector('[data-buy-block] [data-bag-add]') || document.querySelector('[data-buy-block]');
      if (!buy) return;
      var past = false, bandOn = false, footOn = false;
      function update() {
        var on = past && !bandOn && !footOn;
        bar.classList.toggle('is-visible', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      }
      /* "gone" = the button's bottom edge is above the viewport. Read from geometry on every scroll frame rather
         than from an IntersectionObserver: an observer only fires when the button crosses the viewport, so a fling
         or a jump that skips it would never report the exit. */
      var ticking = false;
      function check() { past = buy.getBoundingClientRect().bottom < 0; update(); }
      window.addEventListener('scroll', function () { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; check(); }); }, { passive: true });
      window.addEventListener('resize', check);
      check();
      var band = document.querySelector('.ovit-band');
      if (band) new IntersectionObserver(function (en) { bandOn = en[0].isIntersecting; update(); }, { threshold: 0 }).observe(band);
      var footer = document.querySelector('.footer') || document.querySelector('footer');
      if (footer) new IntersectionObserver(function (en) { footOn = en[0].isIntersecting; update(); }, { threshold: 0 }).observe(footer);
    });
  }

  /* Reviews: "Read all N reviews" reveals every review right here — the row opens into a wall of full
     reviews (no page change, no dead end); the same button folds it back and returns to the heading */
  function bindReviewExpand(root) {
    (root || document).querySelectorAll('.ovit-reviews__link--expand').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      var sec = btn.closest('.ovit-reviews');
      if (!sec) return;
      btn.addEventListener('click', function () {
        var open = !sec.classList.contains('is-expanded');
        sec.classList.toggle('is-expanded', open);
        sec.querySelectorAll('.ovit-rextra').forEach(function (x) { x.hidden = !open; });
        sec.querySelectorAll('.ovit-rmini__full, .ovit-rbuyer__full').forEach(function (f) {
          f.hidden = !open;
          var short = f.previousElementSibling;
          if (short) short.hidden = open;
        });
        btn.textContent = open ? (btn.dataset.less || 'Show fewer') : (btn.dataset.more || 'Read all reviews');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) {
          var header = document.querySelector('.header');
          var top = sec.getBoundingClientRect().top + window.pageYOffset - (header ? header.offsetHeight : 0) - 8;
          if (window.pageYOffset > top) window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        }
      });
    });
  }

  /* A slim scroll bar under a swipe row: the thumb mirrors the position, drag it or click the track to move,
     hidden when the row already fits. The bar's scroller is the previous sibling. */
  function bindScrollbars(root) {
    (root || document).querySelectorAll('.ovit-scrollbar').forEach(function (bar) {
      if (bar.dataset.bound) return;
      bar.dataset.bound = '1';
      var scroller = bar.previousElementSibling;
      while (scroller && scroller.classList.contains('ovit-reviews__link')) scroller = scroller.previousElementSibling;
      var track = bar.querySelector('.ovit-scrollbar__track');
      var thumb = bar.querySelector('.ovit-scrollbar__thumb');
      if (!scroller || !track || !thumb) return;
      var max = 0, tw = 0, thw = 0;
      function measure() {
        max = scroller.scrollWidth - scroller.clientWidth;
        var fits = max <= 2 || getComputedStyle(scroller).overflowX === 'visible';
        bar.hidden = fits;
        if (fits) return;
        tw = track.clientWidth;
        thw = Math.max(34, Math.round(tw * scroller.clientWidth / scroller.scrollWidth));
        thumb.style.width = thw + 'px';
        position();
      }
      function position() {
        if (bar.hidden || max <= 0) return;
        var x = Math.round((scroller.scrollLeft / max) * (tw - thw));
        thumb.style.transform = 'translateX(' + Math.max(0, Math.min(x, tw - thw)) + 'px)';
      }
      scroller.addEventListener('scroll', position, { passive: true });
      window.addEventListener('resize', measure);
      if ('ResizeObserver' in window) new ResizeObserver(measure).observe(scroller);
      /* drag the thumb */
      var dragX = null, startLeft = 0;
      thumb.addEventListener('pointerdown', function (e) {
        e.preventDefault(); dragX = e.clientX; startLeft = scroller.scrollLeft;
        bar.classList.add('is-dragging'); thumb.setPointerCapture(e.pointerId);
      });
      thumb.addEventListener('pointermove', function (e) {
        if (dragX == null) return;
        scroller.scrollLeft = startLeft + (e.clientX - dragX) * (max / (tw - thw));
      });
      function endDrag(e) { if (dragX == null) return; dragX = null; bar.classList.remove('is-dragging'); try { thumb.releasePointerCapture(e.pointerId); } catch (err) {} }
      thumb.addEventListener('pointerup', endDrag);
      thumb.addEventListener('pointercancel', endDrag);
      /* click the track to jump */
      track.addEventListener('click', function (e) {
        if (e.target === thumb || dragX != null) return;
        var r = track.getBoundingClientRect();
        var ratio = (e.clientX - r.left - thw / 2) / (tw - thw);
        scroller.scrollTo({ left: Math.max(0, Math.min(1, ratio)) * max, behavior: 'smooth' });
      });
      var sec = bar.closest('.ovit-reviews');
      if (sec) new MutationObserver(function () { setTimeout(measure, 50); }).observe(sec, { attributes: true, attributeFilter: ['class'] });
      measure();
      setTimeout(measure, 400);
      window.addEventListener('load', measure);
    });
  }

  /* A swipe row with data-drift drifts along by itself (px per second), pauses while you hover, touch, wheel or
     drag, waits at the end and glides back to the start. Still for prefers-reduced-motion. */
  function bindDrift(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('[data-drift]').forEach(function (scroller) {
      if (scroller.dataset.driftBound) return;
      scroller.dataset.driftBound = '1';
      var speed = parseFloat(scroller.dataset.drift) || 24;
      var pauseUntil = performance.now() + 1500, last = null, pos = scroller.scrollLeft, returning = false;
      function pause(ms) { pauseUntil = Math.max(pauseUntil, performance.now() + ms); }
      ['pointerenter', 'pointerdown', 'touchstart', 'focusin', 'wheel'].forEach(function (ev) {
        scroller.addEventListener(ev, function () { pause(6000); }, { passive: true });
      });
      scroller.addEventListener('pointerleave', function () { pause(1200); });
      var bar = scroller.nextElementSibling;
      if (bar && bar.classList.contains('ovit-scrollbar')) {
        bar.addEventListener('pointerdown', function () { pause(8000); });
        bar.addEventListener('click', function () { pause(8000); });
      }
      scroller.addEventListener('scroll', function () {
        if (returning) return;
        if (Math.abs(scroller.scrollLeft - pos) > 3) { pause(6000); pos = scroller.scrollLeft; }
      }, { passive: true });
      function frame(t) {
        if (last == null) last = t;
        var dt = Math.min(64, t - last); last = t;
        var max = scroller.scrollWidth - scroller.clientWidth;
        var section = scroller.closest('.ovit-reviews');
        var open = section && section.classList.contains('is-expanded');
        if (max > 2 && !open && t > pauseUntil && document.visibilityState === 'visible') {
          if (returning) {
            if (scroller.scrollLeft < 2) { returning = false; pos = 0; pause(1500); }
          } else if (pos >= max - 1) {
            returning = true; pause(3000);
            setTimeout(function () { scroller.scrollTo({ left: 0, behavior: 'smooth' }); }, 2400);
          } else {
            pos = Math.min(max, pos + speed * dt / 1000);
            scroller.scrollLeft = pos;
          }
        } else if (!returning) {
          pos = scroller.scrollLeft;
        }
        window.requestAnimationFrame(frame);
      }
      window.requestAnimationFrame(frame);
    });
  }

  /* In-page links (hero button, sticky bar): scroll under the sticky header */
  function bindScrollLinks(root) {
    (root || document).querySelectorAll('.ovit a[data-scroll]').forEach(function (a) {
      if (a.dataset.bound) return;
      a.dataset.bound = '1';
      a.addEventListener('click', function (e) {
        var href = a.getAttribute('href') || '';
        var at = href.indexOf('#');
        if (at < 0 || href.length <= at + 1) return;
        var target = document.getElementById(href.slice(at + 1));
        if (!target) return;
        e.preventDefault();
        var header = document.querySelector('.header--sticky, .header');
        var offset = header ? header.offsetHeight : 0;
        var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        try { history.replaceState(null, '', href.slice(at)); } catch (err) {}
      });
    });
  }

  /* What fits: the bag toggle — swaps the pair and the customer's words; takes turns by itself when asked
     (pauses while the visitor hovers or touches, and after a tap; still for reduced motion) */
  function bindFits(root) {
    (root || document).querySelectorAll('.ovit-fits').forEach(function (sec) {
      if (sec.dataset.bound) return;
      sec.dataset.bound = '1';
      var tabs = sec.querySelectorAll('.ovit-fits__tab');
      var sets = sec.querySelectorAll('.ovit-fits__set');
      var words = sec.querySelectorAll('.ovit-fits__words');
      var keys = Array.prototype.map.call(tabs, function (t) { return t.dataset.key; });
      var current = keys[0];
      sets.forEach(function (p) { p.hidden = false; });
      words.forEach(function (w) { w.hidden = false; });
      function show(key) {
        current = key;
        tabs.forEach(function (x) { var on = x.dataset.key === key; x.classList.toggle('is-active', on); x.setAttribute('aria-selected', on ? 'true' : 'false'); });
        sets.forEach(function (p) { p.classList.toggle('is-active', p.dataset.key === key); });
        words.forEach(function (w) { if (w.dataset.key) w.classList.toggle('is-active', w.dataset.key === key); });
      }
      sec._showTab = show;
      var pauseUntil = 0;
      function pause(ms) { pauseUntil = Math.max(pauseUntil, performance.now() + ms); }
      tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.key); pause(9000); }); });
      var every = parseInt(sec.dataset.autoplay, 10) || 0;
      if (every > 0 && keys.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var hoverDevice = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (hoverDevice) {
          sec.addEventListener('pointerenter', function () { pause(every * 2); }, { passive: true });
          sec.addEventListener('pointerleave', function () { pause(600); });
        }
        sec.addEventListener('focusin', function () { pause(every * 2); }, { passive: true });
        var last = performance.now();
        setInterval(function () {
          var now = performance.now();
          /* iOS keeps :hover on a section after a touch, so only a real hover device may hold the turn */
          if (now < pauseUntil || document.visibilityState !== 'visible' || (hoverDevice && sec.matches(':hover'))) { last = now; return; }
          if (now - last < every) return;
          last = now;
          var i = keys.indexOf(current);
          show(keys[(i + 1) % keys.length]);
        }, 250);
      }
    });
  }

  /* Book: "Write a review" reveals Judge.me's widget (kept for its form and Google's stars) and opens its form */
  function bindWriteReview(root) {
    (root || document).querySelectorAll('[data-write-review]').forEach(function (btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function () {
        document.body.classList.add('ovit-jdgm-open');
        var w = document.querySelector('.jdgm-review-widget, .jdgm-rev-widg');
        if (!w) return;
        w.scrollIntoView({ behavior: 'smooth', block: 'start' });
        setTimeout(function () { var l = w.querySelector('.jdgm-write-rev-link'); if (l) l.click(); }, 500);
      });
    });
  }

  /* ------------------------------------------------------------------ */
  /* Card slideshow (John, Sep 11): every bag card cycles its photos —   */
  /* the product's own, or the ones picked on the block. The card keeps  */
  /* ONE real <img> (the swatch logic owns it); a second layer fades the */
  /* next photo in on top, then hands it down and fades out over the     */
  /* same picture, so there is never a flash and never a second owner.   */
  /* ------------------------------------------------------------------ */
  function bindSlides(root) {
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('.ovit-choose__media--slides').forEach(function (media, n) {
      if (media.dataset.slidesBound) return;
      media.dataset.slidesBound = '1';
      var base = media.querySelector('[data-bag-img]');
      if (!base) return;
      var bag = media.closest('.ovit-bag');
      var sec = media.closest('.ovit-choose');
      var every = parseInt(sec && sec.dataset.slideEvery, 10) || 3000;
      var fade = parseInt(sec && sec.dataset.slideFade, 10) || 500;
      var picked = [];
      try { picked = JSON.parse(media.getAttribute('data-slides') || '[]') || []; } catch (e) { picked = []; }

      var over = document.createElement('img');
      over.className = 'ovit-choose__slide';
      over.alt = '';
      over.setAttribute('aria-hidden', 'true');
      over.setAttribute('decoding', 'async');
      media.appendChild(over);

      var i = 0, gen = 0, timer = null, live = false;
      /* the three cards are offset so they never all turn on the same beat */
      var phase = (n % 3) * 600;

      /* The reel always starts on the photo the swatch chose, so picking Rose
         can never leave a black bag sitting on the card. */
      function reel() {
        if (picked.length) {
          return [{ src: base.getAttribute('src') || '', srcset: base.getAttribute('srcset') || '' }].concat(picked);
        }
        var opts = bag ? bagOptions(bag) : [];
        var o = opts[parseInt(bag && bag.dataset.index, 10) || 0];
        return (o && o.imgs) || [];
      }

      function step() {
        if (document.hidden) return;
        var r = reel();
        if (r.length < 2) return;
        i = (i + 1) % r.length;
        var s = r[i];
        if (!s || !s.src) return;
        var g = ++gen;
        var pre = new Image();
        pre.onload = pre.onerror = function () {
          if (g !== gen) return;
          over.setAttribute('src', s.src);
          if (s.srcset) over.setAttribute('srcset', s.srcset); else over.removeAttribute('srcset');
          requestAnimationFrame(function () {
            if (g !== gen) return;
            over.classList.add('is-on');
            setTimeout(function () {
              if (g !== gen) return;
              base.setAttribute('src', s.src);
              if (s.srcset) base.setAttribute('srcset', s.srcset); else base.removeAttribute('srcset');
              over.classList.remove('is-on');
            }, fade + 40);
          });
        };
        pre.src = s.src;
      }

      /* a chain, not setInterval: a backgrounded tab cannot pile ticks up */
      function start() {
        if (live) return;
        live = true;
        timer = setTimeout(function tick() {
          step();
          timer = setTimeout(tick, every);
        }, every + phase);
      }
      function stop() { live = false; if (timer) { clearTimeout(timer); timer = null; } }

      media._slidesReset = function () { gen++; i = 0; over.classList.remove('is-on'); };

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) start(); else stop(); });
        }, { threshold: 0.2 }).observe(media);
      } else {
        start();
      }
    });
  }

  function init(root) {
    bindReviewToggles(root); bindWriteReview(root); bindStrips(root); bindSlices(root); bindOffer(root);
    bindBags(root); bindSlides(root); bindChooseTabs(root); bindSticky(root); bindScrollLinks(root); bindFits(root);
    bindDrawer(root); bindPdpSticky(root); bindReviewExpand(root); bindScrollbars(root); bindDrift(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  /* Theme editor: re-bind when a section is (re)loaded; show the block being edited */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var set = e.target.closest('.ovit-fits__set');
    if (set) { var fits = set.closest('.ovit-fits'); if (fits && fits._showTab) fits._showTab(set.dataset.key); }
    var card = e.target.closest('.ovit-choose__card');
    if (card) { var sec = card.closest('.ovit-choose'); if (sec && sec._showTab) sec._showTab(card.dataset.key); }
  });
})();

/* The product split: one screen tall. Measure what sits above it (announcement bar + header) so the first
   photo — the whole bag — is on screen when the page opens. */
(function () {
  var split = document.querySelector('.ovit-pdp__split');
  if (!split) return;
  var set = function () {
    var top = Math.round(split.getBoundingClientRect().top + window.scrollY);
    if (top > 0 && top < 400) split.style.setProperty('--ovit-header-h', top + 'px');
  };
  set();
  window.addEventListener('resize', set);
  window.addEventListener('load', set);
})();

/* What fits: warm the other pairs after the first paint, so the crossfade never lands on an unloaded image
   (iPhone Safari showed a white block once). */
window.addEventListener('load', function () {
  setTimeout(function () {
    document.querySelectorAll('.ovit-fits__set img[loading="lazy"]').forEach(function (img) {
      img.loading = 'eager';
      if (img.dataset.src) img.src = img.dataset.src;
    });
  }, 1500);
});

/* One spring for the header (John, Sep 10: "smooth, think nervous system regulating"): critically damped,
   natural frequency 9 rad/s - it follows the scroll with a breath of lag, settles in about half a second and can
   never overshoot or ring. Integrated in four sub-steps so it stays stable even when a busy phone drops to 20 fps
   (a single explicit step diverged at 30 fps and showed as the glass flashing). Returns [x, v]. */
function ovitSpringStep(x, v, target, dt) {
  var m = 0.2, w = 9, k = m * w * w, c = 2 * m * w, n = 4, h = dt / n;
  for (var i = 0; i < n; i++) {
    v += ((-k * (x - target)) - (c * v)) / m * h;
    x += v * h;
  }
  if (x < -0.05) x = -0.05; else if (x > 1.05) x = 1.05;
  return [x, v];
}

/* The header's glass, weighted. Scrolling the first 144 px forms the frosted bar; the amount of glass follows
   the scroll through a critically damped spring (see ovitSpringStep), and the white wordmark crossfades into the charcoal one on the same
   curve, in the same box. One variable drives it all; Venue's class flip only recolors the nav. */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  var header = document.querySelector('.header[data-transparent-header="true"]');
  if (!header) return;
  var white = header.querySelector('.header__logo-img--transparent');
  var dark = header.querySelector('.header__logo-img:not(.header__logo-img--transparent)');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var range = 144, p = 0, v = 0, target = 0, raf = null, last = 0;
  var lightText = [242, 242, 242], darkText = [17, 17, 17];
  function mixc(a, b, t) { return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ', ' + Math.round(a[1] + (b[1] - a[1]) * t) + ', ' + Math.round(a[2] + (b[2] - a[2]) * t) + ')'; }
  function apply() {
    header.style.setProperty('--ovit-glass-scroll', Math.min(1, Math.max(0, p)).toFixed(3));
    /* the nav follows the same curve: Venue paints its transparent-state colour from this variable, and its
       "stuck" colour is the dark end of the same ramp, so the class flip changes nothing visible */
    header.style.setProperty('--header-transparent-text-color', mixc(lightText, darkText, p));
    header.style.setProperty('--header-transparent-text-color-light', mixc(lightText, darkText, p).replace('rgb(', 'rgba(').replace(')', ', .5)'));
    if (white) white.style.opacity = (1 - p).toFixed(3);
    if (dark) dark.style.opacity = p.toFixed(3);
  }
  function tick(now) {
    var dt = last ? Math.min((now - last) / 1000, 1 / 20) : 1 / 60;
    last = now;
    var s = ovitSpringStep(p, v, target, dt);
    p = s[0]; v = s[1];
    if (Math.abs(p - target) < 0.0015 && Math.abs(v) < 0.02) { p = target; v = 0; apply(); raf = null; last = 0; return; }
    apply();
    raf = requestAnimationFrame(tick);
  }
  function onScroll() {
    target = Math.min(Math.max(window.scrollY / range, 0), 1);
    if (reduce) { p = target; v = 0; apply(); return; }
    if (!raf) { last = 0; raf = requestAnimationFrame(tick); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  p = target = Math.min(Math.max(window.scrollY / range, 0), 1);
  apply();
})();

/* The header compresses past the hero (John, Sep 10): 89 px of glass over the photograph, 55 px once it has
   passed (68 -> 42 on the phone), a golden ratio apart. The bar's height follows the photograph's bottom edge:
   as the last strip slides out from under the bar, the bar shrinks to keep just a lens-lip of photograph beneath
   it, through the same spring as the frost - a slow scroll rides the edge, a flick glides and settles.
   Scrolling back up plays it in reverse. Other pages open compact (CSS). */
(function () {
  if (!document.body.classList.contains('template-index')) return;
  var header = document.querySelector('.header[data-transparent-header="true"]');
  var hero = document.querySelector('.ovit-hero');
  var img = hero && (hero.querySelector('.ovit-hero__img') || hero);
  if (!header || !img) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var full = 89, compact = 55, lip = 21, c = 0, v = 0, target = 0, raf = null, last = 0, shown = -1;
  function measure() {
    var cs = getComputedStyle(header);
    full = parseFloat(cs.getPropertyValue('--ovit-hd-full')) || 89;
    compact = parseFloat(cs.getPropertyValue('--ovit-hd-compact')) || 55;
    lip = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ovit-glass-lip')) || 21;
  }
  function apply() {
    var hd = full + (compact - full) * Math.min(1, Math.max(0, c));
    hd = Math.round(hd * 100) / 100;
    if (hd === shown) return;
    shown = hd;
    header.style.setProperty('--ovit-hd', hd + 'px');
    header.classList.toggle('ovit-hd-compact', hd <= compact + 0.5);
  }
  function retarget() {
    var top = header.getBoundingClientRect().top;
    var avail = img.getBoundingClientRect().bottom - top - lip;   /* photograph left under the bar, minus the lens lip */
    var hd = Math.min(full, Math.max(compact, avail));
    target = (full - hd) / (full - compact);
  }
  function tick(now) {
    var dt = last ? Math.min((now - last) / 1000, 1 / 20) : 1 / 60;
    last = now;
    var s = ovitSpringStep(c, v, target, dt);
    c = s[0]; v = s[1];
    if (Math.abs(c - target) < 0.0015 && Math.abs(v) < 0.02) { c = target; v = 0; apply(); raf = null; last = 0; return; }
    apply();
    raf = requestAnimationFrame(tick);
  }
  function onScroll() {
    retarget();
    if (reduce) { c = target; v = 0; apply(); return; }
    if (!raf) { last = 0; raf = requestAnimationFrame(tick); }
  }
  measure();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', function () { measure(); onScroll(); });
  window.addEventListener('load', function () { measure(); onScroll(); });
  retarget(); c = target; apply();
})();

/* The homepage hero: measure the transparent header so the panel centres in the space below it */
(function () {
  var hero = document.querySelector('.ovit-hero--panel');
  var header = document.querySelector('.header');
  if (!hero || !header) return;
  var set = function () { var h = header.getBoundingClientRect().height; if (h > 20 && h < 300) hero.style.setProperty('--ovit-header-h', Math.round(h) + 'px'); };
  set(); window.addEventListener('resize', set); window.addEventListener('load', set);
})();

} /* window.__ovitHome */
